export const BED_OPTIONS = [
    'standard',
    'bunk_top',
    'bunk_bottom',
    'couch',
    'sofa_bed',
    'inflatable',
];
export const BED_OPTION_DEFINITIONS = {
    standard: { value: 'standard', label: 'Standard', comfort: 1, requiresClimbing: false },
    bunk_bottom: {
        value: 'bunk_bottom',
        label: 'Bunk (bottom)',
        comfort: 0.8,
        requiresClimbing: false,
    },
    bunk_top: { value: 'bunk_top', label: 'Bunk (top)', comfort: 0.6, requiresClimbing: true },
    sofa_bed: { value: 'sofa_bed', label: 'Sofa bed', comfort: 0.5, requiresClimbing: false },
    couch: { value: 'couch', label: 'Couch', comfort: 0.3, requiresClimbing: false },
    inflatable: { value: 'inflatable', label: 'Inflatable', comfort: 0.2, requiresClimbing: false },
};
export function isBedOption(value) {
    return typeof value === 'string' && BED_OPTIONS.includes(value);
}
export function comfortOf(option) {
    return BED_OPTION_DEFINITIONS[option].comfort;
}
//# sourceMappingURL=bedOptions.js.map